import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function PricingTrungTam() {
  const cardOneItems = [{
    label: "CHI PHÍ BAN ĐẦU",
    amount: "50.000.000",
    unit: "VNĐ / cơ sở đầu tiên"
  }, {
    label: "TỪ CƠ SỞ THỨ 2",
    amount: "20.000.000",
    unit: "VNĐ / cơ sở"
  }, {
    label: "PHÍ HỢP TÁC",
    amount: "3.000.000",
    unit: "VNĐ / tháng / cơ sở"
  }, {
    label: "CƠ SỞ THỨ 2",
    amount: "2.000.000",
    unit: "VNĐ / tháng / cơ sở"
  }];
  return <section id="pricingtrungtam" data-nav="light" className="bg-background text-foreground py-20 md:py-28 relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-18">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground uppercase mb-4">
            BÁO GIÁ DÀNH CHO TRUNG TÂM
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
            Giải pháp hợp tác dành cho Trung tâm Tiếng Anh, Kỹ năng sống, Văn hóa và các đơn vị giáo dục.
          </p>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Card 1: Robotics Partnership Model */}
          <Card className="border border-border/80 bg-card shadow-md rounded-2xl flex flex-col justify-between overflow-hidden">
            <CardHeader className="pb-6 border-b border-border/60">
              <span className="text-xs uppercase tracking-wider font-semibold text-primary mb-2">
                ROBOTICS
              </span>
              <CardTitle className="text-xl sm:text-2xl font-bold text-foreground leading-snug">
                TRUNG TÂM TIẾNG ANH / KNS / VĂN HÓA
              </CardTitle>
            </CardHeader>

            <CardContent className="pt-6 flex-1 flex flex-col justify-between gap-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {cardOneItems.map((item, i) => <div key={item.label} data-index={i} className="p-4 rounded-xl bg-muted/40 border border-border/40 flex flex-col justify-between">
                    <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">
                      {item.label}
                    </span>
                    <div>
                      <div className="text-2xl sm:text-3xl font-extrabold text-foreground tracking-tight">
                        {item.amount}
                      </div>
                      <div className="text-xs sm:text-sm text-muted-foreground mt-1">
                        {item.unit}
                      </div>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Card 2: Programming, AI Model */}
          <Card className="border border-border/80 bg-card shadow-md rounded-2xl flex flex-col justify-between overflow-hidden">
            <CardHeader className="pb-6 border-b border-border/60">
              <span className="text-xs uppercase tracking-wider font-semibold text-secondary mb-2">
                LẬP TRÌNH, AI, …
              </span>
              <CardTitle className="text-xl sm:text-2xl font-bold text-foreground leading-snug">
                LẬP TRÌNH, AI, …
              </CardTitle>
            </CardHeader>

            <CardContent className="pt-8 pb-8 flex-1 flex flex-col items-center justify-center text-center gap-8">
              <div className="space-y-3 max-w-sm">
                <div className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight">
                  Liên hệ để nhận báo giá
                </div>
              </div>

              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-sm font-semibold px-8 py-6 text-base rounded-xl transition-all">
                <Link to="/FreeTrialContactPage">
                  ĐĂNG KÝ TƯ VẤN
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}